/* --------------------------------------------------------------------- */
/* Formato y etiquetas legibles                                           */
/*                                                                        */
/* El código de sala llega como texto libre desde la telemetría. El       */
/* parseo es deliberadamente tolerante: acepta TEX04 y TEXCUMAR04, ceros  */
/* a la izquierda y cualquier número de dígitos, y si algo no encaja      */
/* devuelve el código crudo en lugar de romperse.                         */
/* --------------------------------------------------------------------- */

export function formatValue(value, digits = 2) {
  return value === null || value === undefined || Number.isNaN(Number(value))
    ? '—'
    : Number(value).toFixed(digits);
}

export function formatCount(value) {
  return Number(value || 0).toLocaleString('es-EC');
}

export function baseLabel(code) {
  const match = /^TEX(?:CUMAR)?[ ]*0*([0-9]+)$/i.exec(String(code || '').trim());
  return match ? `Texcumar ${Number(match[1])}` : code;
}

export function roomCodeLabel(code) {
  const value = String(code || '').trim();
  return /^[0-9]+$/.test(value) ? String(Number(value)) : value;
}

// Etiqueta de una UNIDAD (la columna `sala`). No identifica una sala de
// cultivo: TEX04-002 contiene dos. Se conserva para el respaldo cuando el
// catálogo no tiene nombre propio.
export function roomLabel(sala) {
  const [base, room] = String(sala || '').split('-', 2);
  return `${baseLabel(base)} - Sala ${roomCodeLabel(room)}`;
}

/* --------------------------------------------------------------------- */
/* Nombre de la sala de cultivo real                                      */
/*                                                                        */
/* La sala real es el par (sala, sensor_num) y su nombre lo pone el        */
/* catálogo: «Sala U», «Sala W»… Si una serie todavía no está catalogada   */
/* —una sala nueva que empieza a publicar— se degrada a la unidad más el   */
/* sensor, que es feo pero inequívoco, en vez de dejarla sin identificar.  */
/* --------------------------------------------------------------------- */

// Una unidad puede contener DOS salas de cultivo. Sin el número de sensor, las
// dos caen en la misma etiqueta y el desplegable ofrece dos opciones idénticas
// que no hay forma de distinguir ni de elegir a conciencia.
function conSensor(etiqueta, sensorNum) {
  return sensorNum === null || sensorNum === undefined ? etiqueta : `${etiqueta} · S${sensorNum}`;
}

export function roomName(room) {
  if (!room) return '—';
  if (room.nombre) return room.nombre;
  return conSensor(roomLabel(room.sala), room.sensor_num);
}

// Versión corta para tablas y listas, donde repetir el nombre de la base en
// cada fila solo gasta ancho.
export function roomShortName(room) {
  if (!room) return '—';
  if (room.nombre) return room.nombre;
  const [, unidad] = String(room.sala || '').split('-', 2);
  return conSensor(`Sala ${roomCodeLabel(unidad)}`, room.sensor_num);
}

/* Etiqueta de una opción del desplegable de salas.
 *
 * No lleva el nombre de la base: la sala solo se puede elegir después de fijar
 * la base, así que repetirlo en cada opción sería ruido. */
export function roomOptionLabel(room) {
  return roomShortName(room);
}
